<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { RouterView } from 'vue-router'
import AppHeader from '@/components/app/AppHeader.vue'

const route = useRoute()
const isAuthRoute = computed(
  () => typeof route.name === 'string' && route.name.startsWith('auth-')
)
</script>

<template>
  <v-app :class="['app-frame', { 'app-frame--auth': isAuthRoute }]">
    <AppHeader />
    <v-main :class="['app-main', { 'app-main--auth': isAuthRoute }]">
      <RouterView />
    </v-main>
  </v-app>
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use '/src/scss/settings.scss';
</style>
